var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Action Log"}},[_c('Log')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }